import React from 'react'

export function renderInputField(props) {
  const {input, name, label, type, meta: { touched, error }} = props

  return (
    <div className="form-group">
      { label && <label htmlFor={name}>{label}</label> }
      <input className={`form-control ${touched && error && 'is-invalid'}`}
             {...input}
             type={type}/>
      { touched && error && <div className="invalid-feedback">{error}</div> }
    </div>
  )
}

export function renderInputLoginField(props) {
  const {
    input,
    name,
    label,
    type,
    meta: { touched, error }
  } = props;

  return (
    <div className="form-group" style={{ marginBottom: '16px' }}>
      <input
        {...input}
        id={name}
        type={type}
        placeholder={label} // Use label as placeholder inside input
        className={`form-control login-input ${touched && error ? 'is-invalid' : ''}`}
        style={{
          backgroundColor: 'transparent',
          border: '5px solid white',
          borderRadius: '40px',
          color: 'white',
          fontSize: '16px',
          padding: '12px',
          outline: 'none',
          textAlign: 'center'
        }}
      />
      {touched && error && (
        <div className="invalid-feedback">{error}</div>
      )}
    </div>
  );
}

export function renderTextAreaField(props) {
  const {input, name, label, meta: { touched, error }} = props

  return (
    <div className="form-group">
      { label && <label htmlFor={name}>{label}</label> }
      <textarea className={`form-control ${touched && error && 'is-invalid'}`}
             {...input} />
      { touched && error && <div className="invalid-feedback">{error}</div> }
    </div>
  )
}

export function renderSelectField(props) {
  const {input, name, label, meta: { touched, error }, children} = props

  return (
    <div className="form-group">
      { label && <label htmlFor={name}>{label}</label> }
      <select className={`form-control ${touched && error && 'is-invalid'}`}
             {...input}>
        {children}
      </select>
      { touched && error && <div className="invalid-feedback">{error}</div> }
    </div>
  )
}
